class LqdSectionHandler extends elementorModules.frontend.handlers.Base {

	modelSettings = false;

	constructor( ...args ) {

		super( ...args );

		const modelCID = this.getModelCID();

		this.modelSettings = elementorFrontend.config.elements.data[ modelCID ];

		if ( !this.modelSettings ) {
			return;
		}

		this.checkStickyRow();
		this.checkStickyBar();
		this.checkStickyBarPlacement();
		this.checkShowHideOnSticky();

	}

	onElementChange( prop ) {

		switch ( prop ) {
			case 'lqd_sticky_row':
			case 'lqd_sticky_row_anchor':
			case 'lqd_sticky_row_offset':
				this.checkStickyRow();
				break;

			default:
				break;
		}

	}

	getDefaultSettings() {
		return {
			classnames: {
				stickyBarWrap: 'lqd-stickybar-wrap',
				stickyBarLeft: 'lqd-stickybar-left',
				stickyBarRight: 'lqd-stickybar-right',
				showOnSticky: 'lqd-show-onstuck',
				hideOnSticky: 'lqd-hide-onstuck',
				stickyRow: 'lqd-css-sticky',
			}
		}
	}

	checkStickyRow() {

		const stickyRow = this.modelSettings.get( 'lqd_sticky_row' );
		const anchor = this.modelSettings.get( 'lqd_sticky_row_anchor' );
		const offset = this.modelSettings.get( 'lqd_sticky_row_offset' );
		const classnames = this.getSettings( 'classnames' );

		if ( 'lqd-css-sticky' === stickyRow ) {
			this.$element.addClass( classnames.stickyRow );
			this.$element.css( {
				top: 'auto',
				[ anchor ]: offset
			} );
		} else {
			this.$element.removeClass( classnames.stickyRow );
			this.$element.css( {
				top: '',
				bottom: ''
			} );
		}

	}

	checkStickyBar() {

		const stickyBar = this.modelSettings.get( 'sticky_bar' );
		const classnames = this.getSettings( 'classnames' );

		if ( 'yes' === stickyBar ) {
			this.$element.addClass( classnames.stickyBarWrap );
		} else {
			this.$element.removeClass( [ classnames.stickyBarWrap, classnames.stickyBarLeft, classnames.stickyBarRight ] );
		}

	}

	checkStickyBarPlacement() {

		const stickyBar = this.modelSettings.get( 'sticky_bar' );
		const stickyBarPlacement = this.modelSettings.get( 'stickybar_placement' );
		const classnames = this.getSettings( 'classnames' );

		if ( 'yes' !== stickyBar ) {
			return this.$element.removeClass( [ classnames.stickyBarLeft, classnames.stickyBarRight ] )
		}

		this.$element
			.removeClass( [ classnames.stickyBarLeft, classnames.stickyBarRight ] )
			.addClass( stickyBarPlacement );

	}

	checkShowHideOnSticky() {

		const showOnSticky = this.modelSettings.get( 'show_on_sticky' );
		const hideOnSticky = this.modelSettings.get( 'hide_on_sticky' );
		const { classnames } = this.getDefaultSettings();

		this.$element.removeClass( [ classnames.hideOnSticky, classnames.showOnSticky ] )

		if ( classnames.showOnSticky === showOnSticky ) {
			this.$element.addClass( classnames.showOnSticky );
		}
		if ( classnames.hideOnSticky === hideOnSticky ) {
			this.$element.addClass( classnames.hideOnSticky );
		}

	}

}

export default ( $element ) => {
	elementorFrontend.elementsHandler.addHandler( LqdSectionHandler, { $element } );
};